// ShipmentDetails.js
import React, { useEffect, useState } from "react"
import {
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionBody,
  Col,
  Row,
  Card,
  CardBody,
  Label,
  Button,
} from "reactstrap"
import { getShipmentDetails, invoiceDownload } from "http/order/order"
import { formatNumberWithCommas, uId } from "common/utility"
import { startCase } from "lodash"
import { format } from 'date-fns';
import { FiCopy } from 'react-icons/fi';
import { Tooltip } from "react-tooltip"

const AdminShipmentDetail = ({ orderCode, setToastInfo }) => {
  const [open, setOpen] = useState("")
  const [deliveryDetails, setDeliveryDetails] = useState(null)
  const [productOpen, setProductOpen] = useState({}
  );
  const [hasError, setHasError] = useState([])
  const [copiedId, setCopiedId] = useState(null);

  const toggleProduct = (index, accordionId) => {
    setProductOpen(prevOpen => ({
      ...prevOpen,
      [index]: prevOpen[index] === accordionId ? undefined : accordionId
    }))
  }

  const toggle = id => {
    if (open === id) {
      setOpen()
    } else {
      setOpen(id)
    }
  }

  useEffect(() => {
    if (deliveryDetails) {
      const initialProductOpen = deliveryDetails.reduce((acc, _, index) => ({
        ...acc,
        [index]: index.toString()
      }), {});
      setProductOpen(initialProductOpen);
    }
  }, [deliveryDetails]);

  useEffect(() => {
    fetchShipmentDetails()
  }, [])

  const downloadInvoice = async (invoiceId) => {
    try {
      const res = await invoiceDownload({ invoiceId });
      const match = res.data.match(/PDF_LIST:\[([0-9A-Fa-f]+)\]/);

      if (match) {
        const hexCode = match[1];
        const byteArray = new Uint8Array(hexCode.match(/.{1,2}/g).map(byte => parseInt(byte, 16)));
        const blob = new Blob([byteArray], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = url;
        link.download = `Invoice_${invoiceId}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setToastInfo({
          message: "Invoice Downloaded Successfully",
          showToast: true,
          role: 'success',
        });
      }
    } catch (err) {
      setToastInfo({
        message: err.message,
        showToast: true,
        role: 'error',
      });
    }
  }

  const fetchShipmentDetails = async () => {
    try {
      const response = await getShipmentDetails({
        orderCode: orderCode,
      })
      if (response.status) {
        setDeliveryDetails(response?.data?.deliveryDetails)
      }
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <>
      <Accordion flush open={open} toggle={toggle}>
        <AccordionItem>
          <AccordionHeader
            targetId="1"
            style={{ borderBottom: "1px solid #adb5bd", backgroundColor: 'white' }}
          >
            <h5 style={{ fontSize: '1rem', color: '#73778c' }}>
              Shipment Details
            </h5>

          </AccordionHeader>
          <AccordionBody accordionId="1">

            {
              (!deliveryDetails || deliveryDetails?.length === 0) ? (
                <p className="text-center mt-2">No delivery details available at the moment.</p>

              ) : (
                deliveryDetails?.map((item, index) => {
                  const dateStr = item?.date;
                  const timeStr = item?.time;
                  const year = dateStr.substr(0, 4);
                  const month = dateStr.substr(4, 2) - 1; // months are 0-based in JavaScript
                  const day = dateStr.substr(6, 2);
                  const hours = timeStr.substr(0, 2);
                  const minutes = timeStr.substr(2, 2);
                  const seconds = timeStr.substr(4, 2);
                  const date = new Date(year, month, day, hours, minutes, seconds);
                  const formattedDateTime = format(date, 'MMM d, yyyy, hh:mm aa');

                  return (
                    <Card key={uId()} className="mb-3">
                      <CardBody>
                        <Row>
                          <Col xs="12" md="3">
                            <div className="mb-3">
                              <Label htmlFor="dealerType" className="mb-0 fw-bold text-secondary">
                                Delivery ID
                              </Label>
                              <p>{item?.deliveryId}</p>
                            </div>
                          </Col>
                          <Col xs="12" md="3">
                            <div className="mb-3">
                              <Label htmlFor="dealerType" className="mb-0 fw-bold text-secondary">
                                Delivery Creation Date
                              </Label>
                              <p>{formattedDateTime}</p>
                            </div>
                          </Col>



                          <Col xs="12" md="3">
                            <div className="mb-3">
                              <Label htmlFor="dealerType" className="mb-0 fw-bold text-secondary">
                                Delivery Status
                              </Label>

                              <p
                                style={{
                                  width: "55%",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  padding: "8px",
                                }}
                                className="py-1 bg-green rounded-pill text-white"
                              >
                                {startCase(item?.status)}
                              </p>
                            </div>
                          </Col>

                          {item.invoice && <Col xs="12" md="3">
                            <div className="mt-2">
                              <button
                                className="btn btn-outline-success fw-bold me-2"
                                onClick={() => {
                                  downloadInvoice(item?.invoice?.invoiceId)
                                }}
                              >
                                <i className="mdi mdi-download me-2" />
                                Download Invoice
                              </button>
                            </div>
                          </Col>}
                          <Col xs="12" md="3">
                            <div className="d-flex mb-3">
                              <div>
                                <Label htmlFor="dealerType" className="label-styling">
                                  Tracking Details
                                </Label>

                                <p data-tooltip-id={`admin-tracking-tooltip${item.deliveryId}`}>
                                  {item?.trackingId || item?.trackingDetails
                                    ? `${(item?.trackingId || '')} ${(item?.trackingDetails || '').substring(0, 10)}...`
                                    : '-'}
                                </p>
                                <Tooltip
                                  style={{ maxWidth: "200px", marginLeft: "1rem", zIndex: '1000' }}
                                  id={`admin-tracking-tooltip${item.deliveryId}`}
                                  place="top"
                                  content={`${item?.trackingId || ''} ${item?.trackingDetails || ''}`}
                                />
                              </div>

                              <div >
                                <Button color="link" onClick={() => {
                                  navigator.clipboard.writeText(`${item?.trackingId || ''} ${item?.trackingDetails || ''}`);
                                  setCopiedId(item?.deliveryId);
                                  setTimeout(() => setCopiedId(null), 2000); // hide after 2 seconds
                                }}>
                                  <FiCopy size={20} />
                                </Button>
                                {copiedId === item?.deliveryId &&
                                  <div style={{
                                    position: 'absolute',
                                    backgroundColor: '#dff0d8',
                                    color: '#3c763d',
                                    padding: '10px',
                                    borderRadius: '5px',
                                    border: '1px solid #d6e9c6',
                                    marginTop: '10px'
                                  }}>
                                    Copied!
                                  </div>
                                }
                              </div>
                            </div>
                          </Col>

                        </Row>
                        <Row className="">
                          <Col md={12}>
                            <div className="">
                              <h5 className="pt-3 pt-md-0" style={{ fontSize: '1rem', color: '#73778c', borderBottom: '1px solid rgb(173, 181, 189)', paddingBottom: '7px' }}>
                                Product Details
                              </h5>
                              <div style={{ display: "flex", flexDirection: "column" }}>
                                <table className="" style={{ backgroundColor: 'white', width: '100%' }}>
                                  <thead style={{ backgroundColor: '#f8f8fb', color: '#495057' }}>
                                    <tr>
                                      <th style={{ padding: '1rem 10px' }}>Product Image</th>
                                      <th style={{ padding: '1rem 0px' }}>Product Name</th>
                                      <th style={{ padding: '1rem 0px' }}>Qty</th>
                                      {item?.invoice && <th style={{ padding: '1rem 0px' }}>Total Amount</th>}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {item?.productDetails?.map((productItem, index) => {
                                      let imgUrl = productItem?.productImages?.find(
                                        imgItem => imgItem?.image?.primary
                                      )?.image?.paths?.original;
                                      return (
                                        <tr key={uId()} style={{ backgroundColor: 'white', borderBottom: '1px solid #ddd' }}>
                                          <td style={{
                                            padding: "0.5rem 0",
                                            marginBottom: "15px",
                                            paddingLeft: '0.6rem'
                                          }}>
                                            <div className={(imgUrl && !hasError[index]) ? "td-product-img" : "td-no-product-img"}>
                                              {
                                                (imgUrl && !hasError[index]) ? (
                                                  <img
                                                    src={
                                                      process.env.REACT_APP_IMAGE_URL +
                                                      imgUrl
                                                    }
                                                    alt=""
                                                    style={{
                                                      cursor: "pointer",
                                                      width: '100%',
                                                      height: '4.5rem'

                                                    }}
                                                    className="img-fluid d-block"
                                                    onError={(e) => {
                                                      e.target.onerror = null;
                                                      e.target.src = '/no-image.png';
                                                      e.target.style.width = '2.5rem';
                                                      e.target.style.height = '2.5rem';
                                                      setHasError(prevState => {
                                                        const newState = [...prevState];
                                                        newState[index] = true;
                                                        return newState;
                                                      });
                                                    }}
                                                  />
                                                ) : (
                                                  <img
                                                    src={
                                                      "/no-image.png"
                                                    }
                                                    alt=""
                                                    className="img-fluid mx-auto d-block"
                                                    style={{
                                                      cursor: "pointer",
                                                      width: '2rem'
                                                    }}
                                                  />
                                                )
                                              }
                                            </div>
                                          </td>
                                          <td style={{ padding: '0.5rem 0', marginBottom: '15px' }}>
                                            <div>
                                              <p className="font-size-14">{productItem?.productName}</p>
                                            </div>
                                          </td>
                                          <td style={{ padding: '0.5rem 0', marginBottom: '15px' }}>{productItem.quantity}</td>
                                          {item?.invoice && <td style={{ padding: '0.5rem 0', marginBottom: '15px' }}>{formatNumberWithCommas(productItem.price)}</td>}
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  )
                })
              )
            }
          </AccordionBody>
        </AccordionItem>
      </Accordion>

    </>

  )
}

export default AdminShipmentDetail
